import { startsWith } from "lodash"

export type Metrics = (string | undefined | null)[]

function isValidMetric(metric: unknown): metric is string {
  return typeof metric === "string" && metric.length > 0
}

function stripModelPrefixIfMatching(metric: string, modelId: string): string {
  if (!startsWith(metric, "model.")) {
    return metric
  }

  const [, metricModelId, ...values] = metric.split(".")
  if (metricModelId !== modelId) {
    return metric
  }

  return values.join(".")
}

export function getCurrentTemplateMetrics(metrics: Metrics, modelId: string) {
  const strippedMetrics = metrics
    .filter(isValidMetric)
    .map(metric => {
      return stripModelPrefixIfMatching(metric, modelId)
    })
    .filter(isValidMetric)

  return Array.from(new Set(strippedMetrics))
}

interface GetInitialDuplicateSelectedMetricsParams {
  duplicateFromTemplateId?: string | null
  duplicateFromViewMetrics?: string[] | null
  duplicateSourceMetrics?: Metrics | null
  modelId?: string | null
}

// Shared by asset-view and graph's custom-template duplicate flows.
export function getInitialDuplicateSelectedMetrics({
  duplicateFromTemplateId,
  duplicateFromViewMetrics,
  duplicateSourceMetrics,
  modelId,
}: GetInitialDuplicateSelectedMetricsParams) {
  if (duplicateFromTemplateId) {
    if (!duplicateSourceMetrics || !modelId) {
      return null
    }

    return getCurrentTemplateMetrics(duplicateSourceMetrics, modelId)
  }

  return duplicateFromViewMetrics ?? null
}
